import {
  IAction,
  KEEP_THE_SAME,
  StateStatus,
} from '../../../redux/utils/common';
import * as Types from './types';

interface IState {
  NotificationList: {
    status: StateStatus | null;
    data: any;
  };
  addNotification: {
    status: StateStatus | null;
  };
  editNotification: {
    status: StateStatus | null;
  };
  ReminderList: {
    status: StateStatus | null;
    data: any;
  };
  notificationViewStatus: StateStatus | null;
  unreadNotificationCount: {
    status: StateStatus | null;
    data: number;
  };
}

const initialState: IState = {
  NotificationList: {
    status: null,
    data: null,
  },
  addNotification: {
    status: null,
  },
  editNotification: {
    status: null,
  },
  ReminderList: {
    status: null,
    data: null,
  },
  notificationViewStatus: null,
  unreadNotificationCount: {
    status: null,
    data: 0,
  },
};

const NotificationReducer = (
  state: IState = initialState,
  action: IAction
): IState => {
  switch (action.type) {
    case Types.SET_NOTIFICATION_LIST:
      return {
        ...state,
        NotificationList: {
          ...state.NotificationList,
          status: action.status || null,
          data:
            action.data === KEEP_THE_SAME
              ? state.NotificationList.data
              : action.data,
        },
      };
    case Types.SET_ADD_NOTIFICATION:
      return {
        ...state,
        addNotification: {
          ...state.addNotification,
          status: action.status || null,
        },
      };
    case Types.SET_EDIT_NOTIFICATION:
      return {
        ...state,
        editNotification: {
          ...state.editNotification,
          status: action.status || null,
        },
      };
    case Types.SET_REMINDER_LIST:
      return {
        ...state,
        ReminderList: {
          ...state.ReminderList,
          status: action.status || null,
          data:
            action.data === KEEP_THE_SAME
              ? state.ReminderList.data
              : action.data,
        },
      };
    case Types.SET_NOTIFICATION_VIEW:
      return {
        ...state,
        notificationViewStatus: action.status || null,
      };
    case Types.SET_UNREAD_NOTIFICATION_COUNT:
      return {
        ...state,
        unreadNotificationCount: {
          status: action.status || null,
          data:
            action.data === KEEP_THE_SAME
              ? state.unreadNotificationCount.data
              : action.data,
        },
      };
    default:
      return {
        ...state,
      };
  }
};

export default NotificationReducer;

/**
 * Add new Page Steps:
 *
 * navigation -> config -> index.tsx
 * navigation -> config -> Routes.tsx
 *
 */
